import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { GlobalOverlayService } from '../ui/global-overlay.service';

const ACCESS_DENIED_MESSAGE = 'คุณไม่มีสิทธิ์เข้าถึงส่วนนี้';

export const authorizationInterceptor: HttpInterceptorFn = (request, next) => {
  const router = inject(Router);
  const overlay = inject(GlobalOverlayService);

  return next(request).pipe(
    catchError((error: unknown) => {
      const message =
        error instanceof HttpErrorResponse && typeof error.error?.message === 'string'
          ? error.error.message
          : '';

      if (error instanceof HttpErrorResponse && error.status === 403 && message === ACCESS_DENIED_MESSAGE) {
        overlay.error('ไม่มีสิทธิ์เข้าถึง', 'คุณไม่มีสิทธิ์ดำเนินการนี้ ระบบจะพาไปหน้า Dashboard');
        void router.navigateByUrl('/dashboard');
      }

      return throwError(() => error);
    }),
  );
};
